
export const historyInfoActionTypes = {
	PUSH: 'HISTORY_PUSH',
	POP: 'HISTORY_POP',
};